import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "../store";

const sl = require('./sl.i18n.json');
const en = require('./en.i18n.json');

Vue.use(VueI18n);

export default new VueI18n({
    locale: store.getters.currentLanguage,
    messages: {
        sl,
        en
    }
})
